import { useMutation } from "@apollo/client";
import { DELETE_BRAND } from "../apollo/mutations";
import Swal from "sweetalert2";

const useDeleteBrand = (refetch) => {
  const [deleteBrand, { loading, error, data }] = useMutation(DELETE_BRAND);

  const onDeleteBrand = async (record) => {
    try {
      const response = await deleteBrand({
        variables: { deleteBrandId: record?.id },
      });

      console.log("response", response);
      if (response.data?.deleteBrand) {
        Swal.fire({
          title: "Deleted!",
          text: "Your brand has been deleted.",
          icon: "success",
          confirmButtonColor: "#00ff00",
        });
        refetch();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return {
    onDeleteBrand,
    loading,
    error,
    data,
  };
};

export default useDeleteBrand;
